import { useState } from 'react';
import API from '../utils/api';
import toast from 'react-hot-toast';
export const useImageUpload = (endpoint = '/upload/general') => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState('');
  const upload = async (file) => {
    if (!file) return null;
    setUploading(true);
    try {
      const formData = new FormData();
      const key = endpoint.includes('course') ? 'thumbnail' : 'image';
      formData.append(key, file);
      const { data } = await API.post(endpoint, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setPreview(data.imageUrl);
      toast.success('Image uploaded successfully!');
      return { imageUrl: data.imageUrl, publicId: data.publicId };
    } catch (err) {
      toast.error('Upload failed: ' + (err.response?.data?.message || err.message));
      return null;
    } finally { setUploading(false); }
  };
  const deleteImage = async (publicId) => {
    if (!publicId) return;
    try { await API.delete(`/upload/${encodeURIComponent(publicId)}`); } catch (e) {}
  };
  return { upload, deleteImage, uploading, preview, setPreview };
};
